import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SupplierSignupTypeEnum } from '../../enums/supplier-signup-type.enum';
import { OrganisationsService } from '../../services';
import { SupplierSignupTypeInterface } from '../../interfaces/supplier-signup-type.interface';

@Component({
  selector: 'supplier-signup-type',
  styleUrls: ['./supplier-signup-type.component.scss'],
  templateUrl: './supplier-signup-type.component.html',
})
export class SupplierSignupTypeComponent implements OnInit {
  constructor(private organisationService: OrganisationsService) {}

  @Input() organisation;
  @Output() signupTypeSet: EventEmitter<number> = new EventEmitter<number>();

  public SupplierSignupType = SupplierSignupTypeEnum;
  public signupTypes: SupplierSignupTypeInterface[];
  public selectedSignupType;

  ngOnInit() {
    this.organisationService.getSupplierSignupTypes().then((res) => {
      this.signupTypes = res;
      this.selectedSignupType = this.signupTypes[0].id;
    });
  }

  onContinue() {
    this.organisation.supplierSignupTypeId = this.selectedSignupType;

    // set signup type for supplier and raise event to allow boarding to continue
    this.organisationService
      .updateSupplierSignupType({
        organisationId: this.organisation.id,
        supplierSignupTypeId: this.selectedSignupType,
      })
      .then(() => {
        this.signupTypeSet.emit(this.selectedSignupType.id);
      });
  }
}
